import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './styles/arena-polish.css';
import App from './App';
import ScrollToTop from './components/ScrollToTop';
import { installModalManagerGuard } from './utils/muiModalGuard';
import { Buffer } from 'buffer';

window.Buffer = window.Buffer || Buffer;
// before anything can open a dialog or menu: an extension's element on <body>
// must not take the whole page down with it (see the file)
installModalManagerGuard();
const container: any = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    {/* every client-side navigation starts the new page at the top (see the component) */}
    <ScrollToTop />
    <App />
  </BrowserRouter>
);
